import axios from "axios";
import message from "@/utils/message";
import router from "@/router";

const ins = axios.create(); // 创建一个axios的实例
ins.interceptors.response.use(function (resp) {
  if (resp.data.code !== 0) {
    if (resp.data.code == 404) {
      router.push({ path: "/404" });
    }
    message({
      content: resp.data.msg,
      type: "error",
      duration: 1500,
    });
    return null;
  }
  return resp.data.data;
});

export default ins;
